import { ABCFile, ABCCatalog, ActiveLoaderContext, AVM2LoadLibrariesFlags, Natives, } from '@awayfl/avm2';
import { release, assert } from '@awayfl/swf-loader';
import { SecurityDomain } from './SecurityDomain';
import { initLink } from './link';
import { TextField, SceneImage2D, Font, Sprite, MovieClip, MorphSprite, FrameScriptManager, } from '@awayjs/scene';
import { FlashSceneGraphFactory } from './factories/FlashSceneGraphFactory';
import { WaveAudio } from '@awayjs/core';
import { ApplicationDomain } from './system/ApplicationDomain';
import { BitmapImage2D } from '@awayjs/stage';
import { Graphics } from '@awayjs/graphics';
import { SharedObject } from './net/SharedObject';
// alternate of using a `node path`
function normalisePath(p) {
    // maybe http:// or https:// etc, like file://
    var methodIdx = p.indexOf('://');
    var prepend = p[0] === '/' ? '/' : '';
    var parts = p.split(/[\\|/]/).filter(Boolean);
    // when remove '//' from method / will be removed. Restore it
    if (methodIdx > -1)
        parts[0] += '/';
    return prepend + parts.join('/');
}
function browserLoader(url, type) {
    return fetch(normalisePath(url))
        .then(function (r) {
        if (!r.ok) {
            throw "Ups: ".concat(r.statusText, "(").concat(r.status, ")");
        }
        return type === 'json' ? r.json() : r.arrayBuffer();
    })
        .catch(function (e) {
        throw new Error('Unable to load: ' + url + ': ' + e);
    });
}
var PlayerGlobal = /** @class */ (function () {
    function PlayerGlobal() {
    }
    Object.defineProperty(PlayerGlobal.prototype, "stage", {
        get: function () {
            return this._stage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerGlobal.prototype, "content", {
        get: function () {
            return this._content;
        },
        enumerable: false,
        configurable: true
    });
    PlayerGlobal.prototype.dispose = function () {
        console.log('dispose PlayerGlobal');
        ApplicationDomain.currentDomain = null;
        SharedObject._sharedObjects = {};
    };
    PlayerGlobal.prototype.createSecurityDomain = function (avmStage, swfFile, libraries) {
        var _this = this;
        this._avmStage = avmStage;
        if (this._avmStage.avmTestHandler) {
            Natives.print = function (_sec, _expression) {
                var _a, _b;
                var message = '';
                if (arguments.length == 2) {
                    // eslint-disable-next-line prefer-rest-params
                    message = (_a = arguments[1]) === null || _a === void 0 ? void 0 : _a.toString();
                }
                else {
                    for (var i = 1; i < arguments.length; i++) {
                        // eslint-disable-next-line prefer-rest-params
                        message += (_b = arguments[i]) === null || _b === void 0 ? void 0 : _b.toString();
                        if (i !== arguments.length - 1) {
                            message += ' ';
                        }
                    }
                }
                var messageSplit = message.split('\n');
                for (var i = 0; i < messageSplit.length; i++) {
                    console.log('%c Test-Trace from SWF:', 'color: DodgerBlue', messageSplit[i]);
                    avmStage.avmTestHandler.addMessage(messageSplit[i]);
                }
            };
        }
        initLink();
        release || console.log('createSecurityDomain');
        release || assert(!!(libraries & AVM2LoadLibrariesFlags.Builtin));
        release || console.log('Load builtin.abc file');
        var base = PlayerGlobal.builtinsBaseUrl;
        var tasks = [
            browserLoader("".concat(base, "/builtin.abc"), 'arraybuffer')
        ];
        if (libraries & AVM2LoadLibrariesFlags.Playerglobal) {
            tasks.push(browserLoader("".concat(base, "/playerglobal.abcs"), 'arraybuffer'), browserLoader("".concat(base, "/playerglobal.json"), 'json'), browserLoader("".concat(base, "/avmplus.abc"), 'arraybuffer'));
        }
        return Promise.all(tasks).then(function (_a) {
            var builtins = _a[0], pgByte = _a[1], pgJson = _a[2], avmplus = _a[3];
            var sec = new SecurityDomain();
            var builtinABC = new ABCFile({
                url: 'builtin.abc',
                app: sec.system
            }, new Uint8Array(builtins));
            sec.swfVersion = swfFile.swfVersion;
            sec.system.loadABC(builtinABC);
            sec.initialize();
            sec.system.executeABC(builtinABC);
            sec.player = avmStage;
            if (!(libraries & AVM2LoadLibrariesFlags.Playerglobal)) {
                return null;
            }
            release || console.log('Load playerglobal.abcs & playerglobal.json');
            var catalog = new ABCCatalog(sec.system, new Uint8Array(pgByte), pgJson);
            release || console.log('add playerglobals as ABCCatalog');
            sec.addCatalog(catalog);
            var avmPlusABC = new ABCFile({
                url: 'avmplus.File',
                app: sec.system
            }, new Uint8Array(avmplus));
            sec.system.loadAndExecuteABC(avmPlusABC);
            _this._constructStage(sec, swfFile);
            return new FlashSceneGraphFactory(sec);
        });
    };
    PlayerGlobal.prototype._constructStage = function (sec, file) {
        this._contentLoaderInfo = new sec.flash.display.LoaderInfo(this, this._avmStage.root);
        this._contentLoaderInfo.url = new URL(file.url, document.baseURI).href;
        this._applicationDomain = new sec.flash.system.ApplicationDomain();
        this._contentLoaderInfo._setApplicationDomain(this._applicationDomain);
        // not needs, because shuld be resolved from domain
        ActiveLoaderContext.loaderContext = new sec.flash.system.LoaderContext(false, this._applicationDomain);
        this._stage = new sec.flash.display.Stage();
        sec.flash.display.DisplayObject.axClass._activeStage = this._stage;
        this._avmStage.root.adapter = this._stage;
        this._stage.adaptee = this._avmStage.root;
    };
    PlayerGlobal.prototype.enterFrame = function () {
        this._stage && this._stage.enterFrame();
    };
    PlayerGlobal.prototype.resizeStage = function () {
        // it can happen that resizeStage is called before createSecurityDomain has finished and stage exists
        this._stage && this._stage.resizeCallback();
    };
    PlayerGlobal.prototype.addAsset = function (asset, addScene) {
        asset.adapter.loaderInfo = this._contentLoaderInfo;
        switch (asset.assetType) {
            case TextField.assetType: {
                this._applicationDomain.addDefinition(asset.name, asset);
                break;
            }
            case SceneImage2D.assetType:
            case BitmapImage2D.assetType: {
                this._applicationDomain.addDefinition(asset.name, asset);
                break;
                // we should only do this for bitmaps loaded from jpg or png
                // todo:
                //if (this._isImage)
                //	(<AwayDisplayObjectContainer> this._adaptee).addChild(
                //	new Bitmap(<BitmapData> (<SceneImage2D> asset).adapter).adaptee);
            }
            case WaveAudio.assetType: {
                this._applicationDomain.addAudioDefinition(asset.name, asset);
                break;
            }
            case Font.assetType: {
                this._applicationDomain.addFontDefinition(asset.name, asset);
                break;
            }
            case Sprite.assetType: {
                this._applicationDomain.addDefinition(asset.name, asset);
                break;
            }
            case MovieClip.assetType: {
                this._applicationDomain.addDefinition(asset.name, asset);
                // if this is the "Scene 1", we make it a child of the loader
                if (addScene && asset.isAVMScene) {
                    // "Scene 1" when AWDParser, isAVMScene when using SWFParser
                    this._content = asset.adapter.clone();
                    this._content.loaderInfo = this._contentLoaderInfo;
                    this._content.adaptee.reset();
                    this._content.adaptee.firstFrameOnSWFStart = true;
                    FrameScriptManager.invalidAS3Constructors = true;
                    this._stage.adaptee.addChild(this._content.adaptee);
                    FrameScriptManager.execute_as3_constructors_recursiv(this._content.adaptee);
                    this._content.dispatchStaticEvent('added', this._content);
                    this._content.dispatch_ADDED_TO_STAGE(true);
                }
                break;
            }
            case '[asset Generic]': {
                this._applicationDomain.addDefinition(asset.name, asset);
                break;
            }
            case Graphics.assetType:
            case MorphSprite.assetType: {
                break;
            }
            default: {
                console.warn('Loaded unhandled asset-type', asset.assetType);
            }
        }
    };
    PlayerGlobal.builtinsBaseUrl = './assets/builtins/';
    return PlayerGlobal;
}());
export { PlayerGlobal };
